import CreatableSelect from "react-select/creatable";
import { formatPhoneNumber } from "../../../../utils/generalUtils";
import Select from "react-select";
import { SelectContainer } from "../../../../components/ui/layout/SelectContainer";
import Label from "../../../../components/ui/labels/Label";

export const TimeBeforeSelect = ({
    timeOptions,
    timeBeforeSelection,
    setTimeBeforeSelection,
}) => {
    const handleCreate = (inputValue) => {
        const newOption = { label: inputValue, value: Number(inputValue) };
        setTimeBeforeSelection((prev) => [...prev, newOption]);
    };

    return (
        <div>
            <label htmlFor="time-before-select">Time Before Passage (mins):</label>
            <CreatableSelect
                id="time-before-select"
                options={timeOptions}
                isMulti
                isClearable
                onCreateOption={handleCreate}
                onChange={(newValue) => setTimeBeforeSelection(newValue || [])}
                closeMenuOnSelect={true}
                value={timeBeforeSelection}
                placeholder="Select a time in mins"
            />
        </div>
    );
};

export const EmailInput = ({ email, setEmail, errors, setErrors, disabled }) => {
    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            setErrors((prevErrors) => ({ ...prevErrors, email: "Invalid email format" }));
        } else {
            setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
        }
    };

    return (
        <div className="email-input-container w-full">
            <label className="text-sm" htmlFor="email-input">Email:</label>
            <input
                id="email-input"
                placeholder="Email"
                type="text"
                value={email}
                disabled={disabled}
                onChange={handleEmailChange}
                className={`w-full px-2 py-1 border rounded ${
                    errors.email ? "border-red-500" : "border-gray-300"
                }`}
            />
            {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
        </div>
    );
};

export const PhoneInput = ({ phone, setPhone, errors, setErrors, disabled }) => {
    const handlePhoneChange = (e) => {
        const value = e.target.value;
        const formattedValue = formatPhoneNumber(value);
        setPhone(formattedValue);

        if (!/^\(\d{3}\) \d{3}-\d{4}$/.test(formattedValue)) {
            setErrors((prevErrors) => ({ ...prevErrors, phone: "Invalid phone number format" }));
        } else {
            setErrors((prevErrors) => ({ ...prevErrors, phone: "" }));
        }
    };

    return (
        <div className="phone-input-container w-full">
            <label className="text-sm" htmlFor="phone-input">Phone:</label>
            <input
                id="phone-input"
                placeholder="Enter Phone Number"
                type="tel"
                value={phone}
                disabled={disabled}
                onChange={handlePhoneChange}
                className={`w-full px-2 py-1 border rounded ${
                    errors.phone ? "border-red-500" : "border-gray-300"
                }`}
            />
            {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
        </div>
    );
};

export const RunSelect = ({ runNameOptions, selectedRuns, setSelectedRuns, className }) => {
    const ALL_RUNS_OPTION = { label: "All Runs", value: "all" };

    const handleRunSelected = (selectedOptions) => {
        if (!selectedOptions || selectedOptions.length === 0) {
            setSelectedRuns([]);
            return;
        }

        const previouslyHadAllRuns = selectedRuns?.some(opt => opt.value === "all");
        const nowHasAllRuns = selectedOptions.some(opt => opt.value === "all");

        // If "All Runs" was just selected, select all individual runs
        if (nowHasAllRuns && !previouslyHadAllRuns) {
            setSelectedRuns([ALL_RUNS_OPTION, ...runNameOptions]);
            return;
        }

        // If "All Runs" was deselected (was there, now isn't), clear all
        if (previouslyHadAllRuns && !nowHasAllRuns) {
            setSelectedRuns([]);
            return;
        }

        // If user manually selected all individual runs, add "All Runs" indicator
        const individualSelections = selectedOptions.filter(opt => opt.value !== "all");
        if (individualSelections.length === runNameOptions.length && !nowHasAllRuns) {
            setSelectedRuns([ALL_RUNS_OPTION, ...individualSelections]);
            return;
        }

        // If user deselected an individual run while "All Runs" was active, remove "All Runs"
        if (previouslyHadAllRuns && individualSelections.length < runNameOptions.length) {
            setSelectedRuns(individualSelections);
            return;
        }

        setSelectedRuns(selectedOptions);
    }

    const optionsWithAll = [ALL_RUNS_OPTION, ...runNameOptions];

    return (
        <div>
            <Label htmlFor="run-select">Select Runs</Label>
            <SelectContainer>
                <Select
                    className={className}
                    id="run-select"
                    options={optionsWithAll}
                    value={selectedRuns}
                    onChange={handleRunSelected}
                    isMulti
                    closeMenuOnSelect={false}
                    placeholder='Select Runs...'
                    menuPosition='fixed'
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                />
            </SelectContainer>
        </div>
    )
}